export default {
  watch: {
    info(nVal, oVal) {
      if (nVal !== oVal) {
        this.init(nVal);
      }
    },
    'info.evaluation'(nVal, oVal) {
      if (nVal === oVal) return;
      this.initEvaluation(nVal);
    },
  },
  methods: {
    initEvaluation({ title, shopEvaluation }) {
      let str = title;
      let score = 0;
      if (shopEvaluation) {
        str = shopEvaluation.scoreDesc;
        score = shopEvaluation.score;
      }
      this.evaluation = {
        score: score,
        desc: str,
      };
    },
    highlight(status) {
      // 600 用户取餐. 订单完成  http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=115453837
      return status < 600;
    },
    computedBusinessStatus(status, nextTime) {
      // 休息中-有营业时间 休息中-无营业时间
      // 超出配送范围
      // 暂停配送
      // 暂停营业
      let arr = [2, 3, 4, 5];
      let noBusiness = arr.includes(status);
      let timeDesc = '';
      let statusDesc = '';
      switch (status) {
        case 2:
          timeDesc = nextTime ? `${this.$sprintf(this.$t('开始营业%s'), nextTime)}` : '';
          statusDesc = this.$t('休息中');
          break;
        case 3:
          timeDesc = ``;
          statusDesc = this.$t('超出配送范围');
          break;
        case 4:
          timeDesc = ``;
          statusDesc = this.$t('暂停配送');
          break;
        case 5:
          // 暂停营业
          timeDesc = ``
          statusDesc = this.$t('休息中');
          break;
      }
      this.businessStatusMap = {
        noBusiness,
        timeDesc,
        statusDesc,
      };
    },
    goShopDetail() {
      this.$emit('action', 'store', {
        item: this.info,
        shopId: this.shopInfo.shopId,
        orderId: this.orderInfo.orderId,
      });
    },
    showOrderDetail() {
      // 展示详情
      this.$emit('action', 'detail', {
        item: this.info,
        shopId: this.shopInfo.shopId,
        orderId: this.orderInfo.orderId,
        status: this.orderInfo.status,
      });
    },
    btnClick(type, payload) {
      // detail: 详情，store： 门店详情
      let map = {
        1: 'pay', // 去支付
        2: 'oneMoreOrder', // 再来一单
        3: 'evaluation', // 待评价
        4: 'lookEvaluation', // 查看评价
        5: 'debts', // 支付欠款
      };
      let desc = map[type];
      if (!desc) return;
      this.$emit('action', desc, {
        item: this.info,
        shopId: this.shopInfo.shopId,
        orderId: this.orderInfo.orderId,
        status: this.orderInfo.status,
        ...payload,
      });
    },
    starHover(type, index) {
      if (+type === 3) {
        this.evaluation.score = (index + 1) * 100;
      }
    },
    starZero(type) {
      if (+type === 3) {
        this.evaluation.score = 0
      }
    }
  },
};
